module.exports = __webpack_public_path__ + "img/fall-2.9fa4b535.jpg";